/* unplugin-vue-components disabled */import script from "./AccountBalanceSum.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountBalanceSum.vue?vue&type=script&setup=true&lang=js"

import "./AccountBalanceSum.vue?vue&type=style&index=0&id=5f35e403&lang=scss"

const __exports__ = script;

export default __exports__